import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	AccountRegistryFilters,
	AccountWithWalletsAndPermissions,
	createAccountRegistryQuery,
} from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel, SORT_DIRECTIONS } from 'shared/lib';

export type AccountRegistryModel = RegistryModel<
	AccountWithWalletsAndPermissions,
	AccountRegistryFilters,
	JsonApiRequestError
>;

export type CreateAccountRegistryModelParams = {
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export const createAccountRegistryModel = ({
	$accountId,
	...params
}: CreateAccountRegistryModelParams): AccountRegistryModel => {
	const query = createAccountRegistryQuery($accountId);

	const model = createRegistryModel({
		query,
		filters: {
			name: '',
			currencies: [],
		},
		sortField: 'name',
		sortDirection: SORT_DIRECTIONS.ASC,
		...params,
	});

	return model;
};
